import { Filter } from '~/evifields/src/types/Filter';

export const initialFilters: Filter[] = [
  {
    id: 'domain',
    fieldId: 'domain',
    operatorId: 'contains_any',
    values: [],
    fieldType: 'text',
  },
  {
    id: 'access',
    fieldId: 'access',
    operatorId: 'contains_any',
    values: [],
    fieldType: 'text',
  },
  {
    id: 'categories',
    fieldId: 'categories',
    operatorId: 'contains_any',
    values: [],
    fieldType: 'text',
  },
];
